import type { CustomerGroupTypes, PartyRole } from '@hero/schema';

/**
 * Project the multi-valued `Client.roles[]` to a single legacy
 * `CustomerGroupTypes` for the publish-order draft store.
 *
 * The publish flow (and the underlying `Order` schema) still uses the
 * legacy `customerType` enum (`business_customer` / `individual_customer`)
 * to label the receiver / sender side of an order. The unified
 * relations-v2 `Client` model carries `roles[]` instead. This helper
 * picks the dominant legacy-equivalent role so the publish store and
 * the workspace "+ New order" button can prime `setCustomer({ ... })`
 * with a value the existing form expects.
 */
export function rolesToLegacyCustomerType(
  roles: PartyRole[] | undefined,
): CustomerGroupTypes {
  if (!roles?.length) return 'business_customer';
  if (roles.includes('individual_customer')) return 'individual_customer';
  return 'business_customer';
}
